import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import featureService from '../../core/services/featureService';

/**
 * "/" must never render a blank outlet (Navigate alone paints nothing).
 * Redirect to the licensed landing route (first module section, not dashboards).
 */
export default function DefaultLandingPage() {
  const navigate = useNavigate();
  const landingRoute = featureService.getDefaultLandingRoute() || '/document-creation';

  useEffect(() => {
    navigate(landingRoute === '/' ? '/document-creation' : landingRoute, { replace: true });
  }, [landingRoute, navigate]);

  return null;
}
